
import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME, CRUMB_LABEL } from '../constants';
import { apiProvider } from '../api';

const filter = {
	DodListNr: null as string | null,
	ObjednavkaDatDo: null as Date | null,
	ObjednavkaDatOd: null as Date | null,
	PrevedenoPrp: null as boolean | null,
	VstupDatDo: null as Date | null,
	VstupDatOd: null as Date | null,
};

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL,
	dropdownList: {},
	filter,
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: { },
		mode: null,
		afterRowSelection: () => {},
	},
});
